function lmcInitBlueprint(wrap){
  if (location.pathname !== '/' || (window.Shopify && Shopify.designMode) || matchMedia('(prefers-reduced-motion: reduce)').matches) { wrap.remove(); return; }
  document.body.appendChild(wrap);
  wrap.classList.add('lmc-preloader');
  wrap.setAttribute('aria-label','Presentación de LMC Constructora');
  const skip=document.createElement('button');
  skip.type='button'; skip.className='lmc-preloader-skip'; skip.textContent='Omitir presentación'; wrap.appendChild(skip);
  let frame=0, timer=0, closed=false;
  const dismiss=()=>{ if(closed)return; closed=true; cancelAnimationFrame(frame); clearTimeout(timer); wrap.classList.add('is-leaving'); removeEventListener('keydown',onKey); if(document.activeElement===skip)skip.blur(); setTimeout(()=>wrap.remove(),360); };
  const onKey=e=>{if(e.key==='Escape'||e.key==='Tab')dismiss();};
  skip.addEventListener('click',dismiss); addEventListener('keydown',onKey);
  timer=setTimeout(dismiss,4000);
  wrap._lmcCleanup=dismiss;


  const NS="http://www.w3.org/2000/svg";
  const svg=wrap.querySelector('[data-role="svg"]');
  const reduced=matchMedia("(prefers-reduced-motion: reduce)").matches;
  const OUT=0.92, FADE=0.05;
  const holdPct=clamp((parseFloat(wrap.dataset.holdPct)||12)/100,0,0.9);
  const HOLD=1-holdPct; /* HOLD = que % del scroll ocupa la animacion; el resto (holdPct) queda quieto mostrando el logo completo */

  /* módulo real del logo */
  const X0=80, Y0=70, HP=72.75, VP=74.2, T=20, BASE=316.4, XR=318.25;

  /* ---------- retícula: módulo del logo y sus mitades ---------- */
  const gGrid=wrap.querySelector('[data-role="grid"]');
  for(let k=-2;k<=12;k++){
    const x=X0+k*HP/2; if(x<30||x>416) continue;
    line(gGrid,x,28,x,398,k%2?"grid-min":"grid-maj");
  }
  for(let k=-2;k<=12;k++){
    const y=Y0+k*VP/2; if(y<26||y>400) continue;
    line(gGrid,30,y,416,y,k%2?"grid-min":"grid-maj");
  }
  set(gGrid,0.01,0.05,OUT,"fade");

  /* ---------- ejes de replanteo ---------- */
  const gG=wrap.querySelector('[data-role="guides"]');
  [X0+T, X0+T+HP, X0+T+2*HP, XR].forEach((x,i)=>
    set(line(gG,x,32,x,392,"guide"), 0.05+i*0.02, 0.04, OUT, "draw"));
  [Y0, Y0+VP, Y0+2*VP, BASE].forEach((y,i)=>
    set(line(gG,32,y,414,y,"guide"), 0.11+i*0.02, 0.04, OUT, "draw"));
  const o=document.createElementNS(NS,"g");
  line(o,72,BASE,88,BASE,"axis"); line(o,X0,BASE-8,X0,BASE+8,"axis");
  const ot=document.createElementNS(NS,"text");
  ot.setAttribute("class","note"); ot.setAttribute("x",54); ot.setAttribute("y",BASE+16);
  ot.textContent="P0"; o.appendChild(ot); gG.appendChild(o);
  set(o,0.19,0.03,OUT,"fade");

  /* ---------- cotas: ancho total = 1999 (año de fundación) ---------- */
  const gD=wrap.querySelector('[data-role="dims"]');
  const A=X0+T, B=A+HP, C=A+2*HP;
  dim(A,362,B,362,"610",0.20); dim(B,362,C,362,"610",0.22); dim(C,362,XR,362,"610",0.24);
  dim(352,Y0,352,Y0+VP,"623",0.21); dim(352,Y0+VP,352,Y0+2*VP,"623",0.23);
  dim(352,Y0+2*VP,352,BASE,"822",0.25);
  dim(X0,390,XR,390,"1999",0.28,true);
  dim(385,Y0,385,BASE,"2068",0.30);
  dim(X0+2*HP,52,X0+2*HP+T,52,"168",0.32);

  /* ---------- registro de elementos animados ---------- */
  const items=[];
  svg.querySelectorAll("[data-in]").forEach(el=>{
    const type=el.dataset.anim||"fade";
    let len=0;
    if(type==="draw"&&el.getTotalLength){
      len=el.getTotalLength();
      el.style.strokeDasharray=len; el.style.strokeDashoffset=len;
    }
    items.push({el,type,len,a:+el.dataset.in,d:+(el.dataset.dur||0.05),
                out:el.dataset.out?+el.dataset.out:2});
  });

  const letters=[{el:wrap.querySelector('[data-role="letter-l"]'),a:0.73},
                 {el:wrap.querySelector('[data-role="letter-m"]'),a:0.765},
                 {el:wrap.querySelector('[data-role="letter-c"]'),a:0.80}];
  const sub=wrap.querySelector('[data-role="letter-sub"]');
  const logo=wrap.querySelector('[data-role="logo"]');

  const bar=wrap.querySelector('[data-role="bar"]');
  const began=performance.now();
  function loop(now){
    if(closed)return;
    const progress=Math.min((now-began)/2200,1);
    render(progress);
    if(progress<1)frame=requestAnimationFrame(loop);
    else {clearTimeout(timer);timer=setTimeout(dismiss,300);}
  }
  function render(raw){
    let p=clamp(raw,0,1);
    for(const it of items){
      const a=ease(span(p,it.a,it.a+it.d)), b=ease(span(p,it.out,it.out+FADE));
      it.el.style.opacity=a*(1-b);
      if(it.type==="draw"){
        const off=it.len*(1-a);
        if(it.last===undefined||Math.abs(off-it.last)>0.05){ it.el.style.strokeDashoffset=off; it.last=off; }
      }
    }
    letters.forEach(L=>{
      const t=ease(span(p,L.a,L.a+0.05));
      L.el.setAttribute("height",65*t);
      L.el.setAttribute("y",318.5-65*t);
    });
    sub.setAttribute("width",190*ease(span(p,0.86,0.92)));

    const s=1+0.045*ease(span(p,0.94,1));
    logo.setAttribute("transform","translate(199,203) scale("+s.toFixed(4)+") translate(-199,-203)");

    bar.style.width=(raw*100)+"%";
  }

  /* ---------- helpers ---------- */
  function line(par,x1,y1,x2,y2,cls){
    const l=document.createElementNS(NS,"line");
    l.setAttribute("x1",x1);l.setAttribute("y1",y1);l.setAttribute("x2",x2);l.setAttribute("y2",y2);
    l.setAttribute("class",cls);par.appendChild(l);return l;
  }
  function set(el,a,d,out,anim){
    el.dataset.in=a;el.dataset.dur=d;el.dataset.anim=anim;
    if(out!=null)el.dataset.out=out; el.style.opacity=0;
  }
  function dim(x1,y1,x2,y2,label,at,big){
    const g=document.createElementNS(NS,"g"), horiz=(y1===y2);
    const ln=line(g,x1,y1,x2,y2,"dim");
    if(big) ln.setAttribute("stroke-width","1.3");
    tick(g,x1,y1,horiz);tick(g,x2,y2,horiz);
    const t=document.createElementNS(NS,"text");
    t.setAttribute("class","dim-txt"+(big?" big":""));
    t.setAttribute("text-anchor","middle");
    t.textContent=label;
    if(horiz){ t.setAttribute("x",(x1+x2)/2); t.setAttribute("y",y1-(big?11:6)); }
    else{ t.setAttribute("x",0); t.setAttribute("y",0);
          t.setAttribute("transform","translate("+(x1-(big?11:6))+","+((y1+y2)/2)+") rotate(-90)"); }
    g.appendChild(t);
    gD.appendChild(g); set(g,at,0.035,OUT,"fade");
  }
  function tick(g,x,y,horiz){
    line(g,x-3.5,y+3.5,x+3.5,y-3.5,"dim");
    if(horiz) line(g,x,y-7,x,y+7,"dim-ext"); else line(g,x-7,y,x+7,y,"dim-ext");
  }
  function clamp(v,a,b){return v<a?a:v>b?b:v;}
  function span(p,a,b){return clamp((p-a)/(b-a),0,1);}
  function ease(t){return t<.5?2*t*t:1-Math.pow(-2*t+2,2)/2;}

  render(0);
  frame=requestAnimationFrame(loop);

}

function lmcBoot(root){
  (root||document).querySelectorAll('.lmc-blueprint-wrap').forEach(function(wrap){
    if(wrap.dataset.lmcInit) return;
    wrap.dataset.lmcInit="1";
    lmcInitBlueprint(wrap);
  });
}

lmcBoot(document);

// soporte para el editor de temas de Shopify (arrastrar/reordenar/editar en vivo)
document.addEventListener('shopify:section:load', function(e){
  lmcBoot(e.target);
});
document.addEventListener('shopify:section:unload', function(e){
  var wrap = e.target.querySelector && e.target.querySelector('.lmc-blueprint-wrap');
  if(wrap && wrap._lmcCleanup){ wrap._lmcCleanup(); }
});
